/*
  PATISSLAND : Barre "livraison offerte" (franco) dans le tiroir panier + page panier.
  Code deplace du snippet snippets/barre-livraison-offerte.liquid vers ce fichier le
  28/10/2026, logique inchangee. Le pays du visiteur est transmis par l'attribut
  data-country de la balise <script> (rendu Liquid dans le snippet).
  - Seuil franco : 69,00 EUR pour FR, DE, BE, IT, ES (memes 5 pays, tous en euros).
  - Hors de ces pays : la barre ne s'affiche PAS (pas de fausse promesse).
  - S'auto-injecte en haut du tiroir (#CartDrawer .drawer__inner) et au-dessus du
    sous-total sur la page panier (#CartPageForm).
  - Base de calcul : sous-total marchand HORS frais de preparation.
*/
(function(){
  var me = document.currentScript;
  // ---- CONFIGURATION -------------------------------------------------
  var COUNTRY = ((me && me.getAttribute('data-country')) || '').toUpperCase();
  var THRESHOLDS = { FR:6900, DE:6900, BE:6900, IT:6900, ES:6900 }; // centimes EUR
  var FEE_HANDLE = 'frais-de-preparation';
  var FEE_SKU    = 'FRAIS-PREPA';
  // --------------------------------------------------------------------

  var threshold = THRESHOLDS[COUNTRY]; // undefined si pays non couvert -> barre masquee

  var PL = window.PL || { origFetch:(window.fetch?window.fetch.bind(window):null) };

  var I18N = {
    fr:{ progress:"Plus que {amount} pour profiter de la livraison offerte", success:"Felicitations, votre livraison est offerte." },
    en:{ progress:"Only {amount} away from free shipping", success:"Congratulations, you have unlocked free shipping." },
    es:{ progress:"Solo te faltan {amount} para el envio gratis", success:"Enhorabuena, tienes el envio gratis." },
    it:{ progress:"Ti mancano solo {amount} per la spedizione gratuita", success:"Congratulazioni, hai la spedizione gratuita." },
    de:{ progress:"Nur noch {amount} bis zum kostenlosen Versand", success:"Glueckwunsch, Sie erhalten kostenlosen Versand." },
    nl:{ progress:"Nog {amount} tot gratis verzending", success:"Gefeliciteerd, u krijgt gratis verzending." }
  };
  function detectLang(){
    var l='';
    try{ if(window.Shopify && Shopify.locale) l=Shopify.locale; }catch(e){}
    if(!l){ l=document.documentElement.getAttribute('lang')||'en'; }
    l=l.toLowerCase().slice(0,2);
    return I18N[l]?l:'en';
  }
  var T = I18N[detectLang()];

  // Format EUR (virgule decimale) : OK pour les 5 pays (tous en euros).
  function fmt(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; }

  function makeBar(isPage){
    var b=document.createElement('div');
    b.setAttribute('data-pl-freeship','');
    b.className='pl-freeship'+(isPage?' pl-freeship--page':'');
    return b;
  }

  // Injecte la barre dans le shell du tiroir (persistant) et sur la page panier.
  function injectBars(){
    if(!threshold) return;
    var inner=document.querySelector('#CartDrawer .drawer__inner');
    if(inner && !inner.querySelector('[data-pl-freeship]')){
      inner.insertBefore(makeBar(false), inner.firstChild);
    }
    var sub=document.querySelector('#CartPageForm [data-subtotal]');
    if(sub){
      var row=sub.closest('.cart__item-row');
      if(row && !document.querySelector('#CartPageForm [data-pl-freeship]')){
        row.parentNode.insertBefore(makeBar(true), row);
      }
    }
  }

  function bars(){ return document.querySelectorAll('[data-pl-freeship]'); }

  function render(cart){
    var list=bars();
    if(!list.length) return;
    var sub=0;
    (cart.items||[]).forEach(function(it){
      var isFee=(it.handle===FEE_HANDLE)||(it.sku===FEE_SKU);
      if(!isFee) sub+=it.final_line_price;
    });
    if(sub<=0){ list.forEach(function(b){ b.style.display='none'; }); return; }
    var remaining=threshold-sub;
    var success=remaining<=0;
    var pct=Math.max(0, Math.min(100, Math.round(sub/threshold*100)));
    var msg=success ? T.success : T.progress.replace('{amount}','<b>'+fmt(remaining)+'</b>');
    list.forEach(function(b){
      b.style.display='';
      b.classList.toggle('is-success', success);
      b.innerHTML='<p class="pl-freeship__msg">'+msg+'</p>'
        +'<div class="pl-freeship__track"><span class="pl-freeship__fill" style="width:'+pct+'%"></span></div>';
    });
  }

  function update(){
    if(!threshold || !PL.origFetch) return;
    PL.origFetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js').then(function(r){ if (!r.ok) throw new Error('Cart request failed'); return r.json();}).then(render).catch(function(){});
  }

  function init(){ injectBars(); update(); }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  // Le panier a change -> on re-injecte (au cas ou) et on met a jour.
  document.addEventListener('patissland:cart:changed', init);
  document.addEventListener('patissland:cart:synced', init);
  document.addEventListener('cart:updated', init);
})();
